import type { DecisionEngineDestinationUI } from "./definition";

const restRegionToDashboard: Record<string, string> = {
  "iad-01.braze.com": "dashboard-01.braze.com",
  "iad-02.braze.com": "dashboard-02.braze.com",
  "iad-03.braze.com": "dashboard-03.braze.com",
  "iad-04.braze.com": "dashboard-04.braze.com",
  "iad-05.braze.com": "dashboard-05.braze.com",
  "iad-06.braze.com": "dashboard-06.braze.com",
  "iad-07.braze.com": "dashboard-07.braze.com",
  "iad-08.braze.com": "dashboard-08.braze.com",
  "fra-01.braze.eu": "dashboard-01.braze.eu",
  "fra-02.braze.eu": "dashboard-02.braze.eu",
  "eu-01.braze.eu": "dashboard-01.braze.eu",
  "eu-02.braze.eu": "dashboard-02.braze.eu",
  "au-01.braze.com": "dashboard.au-01.braze.com",
  "id-01.braze.com": "dashboard.id-01.braze.com",
  "us-10.braze.com": "dashboard.us-10.braze.com",
};

const isHtmlChannel = (type: string) => type === "email" || type === "inapp";

export const brazeTriggerUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "campaign",
  channelDescription: "Braze (Campaign)",
  getReferenceString: (s, channel) => {
    const withoutPrefix = s.slice(10);
    const filter = isHtmlChannel(channel.type) ? " | newline_to_br" : "";
    return `{{ api_trigger_properties.\${hightouch}.${withoutPrefix}${filter} }}`;
  },
  getResourceUrl: (resource, destinationConfig) =>
    `https://${
      restRegionToDashboard[destinationConfig.region as string]
    }/engagement/campaigns?start=0&limit=10&globalFilter="${encodeURIComponent(
      resource.name,
    )}"&columnFilters%5Bstatus%5D=all&sortby=last_edited&sortdir=-1`,
  isInactive: () => false,
  isPreviewSupported: true,
  getTemplateResourceType: () => "campaign",
  getResourceType: () => "campaign",
  getEmailPreviewMethod: "e2e",
  isTestSendSupported: true,
  showIdentifierField: true,
};

export const brazeCanvasUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "canvas",
  channelDescription: "Braze (Canvas)",
  getReferenceString: (s, channel) => {
    const withoutPrefix = s.slice(10);
    const filter = isHtmlChannel(channel.type) ? " | newline_to_br" : "";
    return `{{ canvas_entry_properties.\${hightouch}.${withoutPrefix}${filter} }}`;
  },
  getResourceUrl: (resource, destinationConfig) =>
    `https://${
      restRegionToDashboard[destinationConfig.region as string]
    }/engagement/canvas?name="${encodeURIComponent(
      resource.name?.replace(" Canvas", ""),
    )}"`,
  isInactive: () => false,
  isPreviewSupported: false,
  getTemplateResourceType: () => "canvas",
  getResourceType: () => "canvas",
  getEmailPreviewMethod: "preview",
  isTestSendSupported: true,
  showIdentifierField: true,
};
